<template>
  <v-container class="device-table-container">
    <checkSubscribtion v-if="role === roleAdmin" style="margin-bottom: 20px"></checkSubscribtion>
    <generate-promo v-if="role === roleAdmin" style="margin-bottom: 20px"></generate-promo>

    <v-layout>
      <v-flex>
        <v-card>
          <v-data-table
            select-all
            v-model="selected"
            :pagination.sync="pagination"
            :headers="headers"
            :items="users"
            item-key="device_id"
            class="device-table"
            :rows-per-page-items="rowPerPage"
            hide-actions
          >
            <template slot="headers" slot-scope="props">
              <tr class="header-text">
                <th v-if="role === roleAdmin">
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  ></v-checkbox>
                </th>
                <th
                  v-for="header in showHeaderColumn"
                  :key="header.text"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                >{{ header.text }}</th>
              </tr>
              <tr class="header-filter">
                <td width="5%" v-if="role === roleAdmin"></td>
                <td width="15%">
                  <v-text-field v-model="filters.device_id.value" single-line hide-details></v-text-field>
                </td>
                <td width="10%">
                  <v-text-field v-model="filters.login.value" single-line hide-details></v-text-field>
                </td>
                <td width="20%">
                  <v-select
                    append-icon="expand_more"
                    :items="statusItemsSearch"
                    hide-details
                    solo
                    color="purple"
                    v-model="filters.status_physical.text"
                  ></v-select>
                </td>
                <td width="10%">
                  <!-- :value="merchants[0]" -->
                  <v-select
                    append-icon="expand_more"
                    :items="merchants"
                    item-text="text"
                    hide-details
                    solo
                    v-model="filters.merchant_login.value"
                  ></v-select>
                </td>
                <td width="10%">
                  <v-select
                    append-icon="expand_more"
                    :items="actionItemsSearch"
                    hide-details
                    solo
                    color="purple"
                    v-model="filters.status_virtual.text"
                  ></v-select>
                </td>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td style="width: 5%" v-if="role === roleAdmin">
                <v-checkbox v-model="props.selected" hide-details color="purple"></v-checkbox>
              </td>
              <td style="width: 15%">{{ props.item.device_id }}</td>
              <td style="width: 10%">{{ props.item.login }}</td>
              <td style="width: 20%">
                <v-select
                  v-if="role === roleAdmin"
                  append-icon="expand_more"
                  color="purple"
                  :items="statusItems"
                  hide-details
                  return-object
                  @change="changeStatusItem($event, props.item.device_id)"
                  :value="statusItems[props.item.status_physical]"
                ></v-select>
                <span
                  class="d-block text-xs-center"
                  v-else
                >{{statusItemsSearch[props.item.status_physical]}}</span>
              </td>
              <td
                style="width: 10%"
                class="text-xs-center"
              >{{props.item.merchant | transformMerchantData}}</td>
              <td style="width: 10%">
                <v-select
                  v-if="role === roleAdmin"
                  append-icon="expand_more"
                  color="purple"
                  :items="actionItems"
                  hide-details
                  return-object
                  @change="changeActionItems($event, props.item.device_id)"
                  :value="actionItems[props.item.status_virtual]"
                ></v-select>
                <span
                  v-else
                  class="d-block text-xs-center"
                >{{actionItems[props.item.status_virtual]}}</span>
              </td>
              <td
                style="width: 10%"
                class="text-xs-center"
              >{{filterSubscription(props.item.subscription, props.item.flag_point)}}</td>
              <!-- props.item.subscription | transformPurchaseData -->
              <td style="width: 5%" class="text-xs-center">
                <v-btn
                  color="purple"
                  dark
                  small
                  icon
                  flat
                  @click="openDeviceModal(props.item.device_id)"
                >
                  <v-icon>email</v-icon>
                </v-btn>
              </td>
              <td style="width: 5%" class="text-xs-center" v-if="role === roleAdmin">
                <v-btn
                  color="purple"
                  small
                  icon
                  flat
                  @click="removeGlassesKey(props.item.device_id)"
                  :disabled="!(role === roleAdmin)"
                >
                  <v-icon>vpn_key</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn color="purple" small icon flat @click="getInfo(props.item)">
                  <v-icon>info</v-icon>
                </v-btn>
              </td>
            </template>
            <template slot="footer" v-if="role === roleAdmin">
              <td :colspan="headers.length + 1" class="text-xs-right">
                <v-btn v-if="!selected.length" flat @click="dialog = true">+ add</v-btn>
                <v-btn v-else flat @click="removeItem" color="red">
                  <v-icon>delete</v-icon>Delete
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pagination">
            <v-pagination
              v-model="filters.page.value"
              circle
              color="purple"
              :length="paginationLength"
              :total-visible="10"
            ></v-pagination>
          </div>
        </v-card>
      </v-flex>

      <v-dialog v-model="dialog" max-width="660">
        <v-card class="add-device-dialog">
          <v-btn flat icon @click="dialog = false" class="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-card-title class="title" color="#707070">Add new device</v-card-title>
          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-text-field
                v-model="newUser.device_id"
                :rules="[rules.required]"
                color="purple"
                min="20"
                counter="20"
                placeholder="Device number"
              ></v-text-field>
              <v-select
                solo
                :items="subscriptionItems"
                v-model="newUser.subscription"
                item-text="subscription"
                item-value="value"
                append-icon="expand_more"
              ></v-select>
              <v-select
                solo
                :items="statusItems"
                :disabled="newUser.subscription === 0"
                v-model="newUser.status_physical"
                append-icon="expand_more"
                color="purple"
              ></v-select>
              <v-select
                solo
                :items="actionItems"
                v-model="newUser.status_virtual"
                append-icon="expand_more"
                color="purple"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn block @click="dialog = false" color="lightgrey">Cancel</v-btn>
            <v-btn block dark @click="addItem" color="purple">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <showModal
        v-model="showDialog"
        :message="dialogMessage"
        :header="dialogHeader"
        :buttonText="dialogButtonText"
      ></showModal>

      <sendEmail v-if="showDialogEmail"></sendEmail>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { addFilters } from "@/utils";
import showModal from "@/components/ShowModal";
import sendEmail from "@/components/sendEmail";
import checkSubscribtion from "@/components/checkSubscribtion";
import generatePromo from "@/components/generatePromo";

export default {
  name: "devices",

  components: {
    showModal,
    sendEmail,
    checkSubscribtion,
    generatePromo
  },

  data: () => ({
    role: "0",
    roleAdmin: "2",
    showDialog: false,
    dialogMessage: "",
    dialogHeader: "",
    dialogButtonText: "",
    page: 1,
    paginationLength: 0,
    rowPerPage: [
      20,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ], // 20 - item per page (ask backend about it)
    filters: {
      page: { value: 1 },
      device_id: { value: "" },
      login: { value: "" },
      merchant_login: { text: "All", value: "" },
      status_virtual: { text: "All", value: "" },
      status_physical: { text: "All", value: "" }
    },
    selected: [],
    dialog: false,
    pagination: {
      sortBy: "device_id"
    },
    headers: [
      {
        text: "Device id",
        value: "device_id",
        align: "left",
        hideForMerchant: false
      },
      { text: "Login", value: "login", hideForMerchant: false },
      {
        text: "Status",
        value: "status",
        sortable: false,
        hideForMerchant: false
      },
      {
        text: "Merchants",
        value: "merchants",
        sortable: false,
        hideForMerchant: false
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        hideForMerchant: false
      },
      {
        text: "Purchase",
        value: "purchase",
        sortable: false,
        hideForMerchant: false
      },
      {
        text: "E-mail",
        value: "email",
        sortable: false,
        hideForMerchant: false
      },
      {
        text: "Remove Key",
        value: "remove_key",
        sortable: false,
        hideForMerchant: true
      },
      {
        text: "Info",
        value: "info",
        sortable: false,
        hideForMerchant: false
      }
    ],
    users: [],
    statusItemsSearch: [
      "In Stock",
      "Awaiting for Activation",
      "Activated",
      "All"
    ],
    statusItems: [
      "In Stock",
      "Awaiting for Activation",
      { text: "Activated", disabled: true }
    ],
    actionItemsSearch: ["No Status", "Allowed", "Forbidden", "All"],
    actionItems: ["No Status", "Allowed", "Forbidden"],
    merchants: [],
    subscriptionItems: [
      {
        subscription: "Charge",
        value: false
      },
      {
        subscription: "Subscription",
        value: 1
      },
      {
        subscription: "Sold by distributor",
        value: 0
      }
    ],
    newUser: {
      device_id: "",
      status_physical: "Awaiting for Activation",
      status_virtual: "No Status",
      subscription: false
    },
    rules: {
      required: value => !!value || "Required"
      // min: value =>
      //   value.length == 20 || "Device ID should contain 20 characters",
      // test: value =>
      //   /^[a-zA-Z0-9]{20}$/g.test(value) ||
      //   "Device ID should include only digit or english letter"
    }
  }),

  created() {
    this.loadData();
  },

  methods: {
    addItem() {
      let newUser = {
        device_id: this.newUser.device_id,
        status_physical: this.newUser.status_physical,
        status_virtual: this.newUser.status_virtual,
        subscription: this.newUser.subscription
      };

      console.log(this.$refs.form.validate());

      if (this.$refs.form.validate()) {
        axios
          .post(
            this.$hostname + "/admin/new_device",
            {
              device_id: newUser.device_id,
              status_physical: this.statusItems.indexOf(
                newUser.status_physical
              ),
              status_virtual: this.actionItems.indexOf(newUser.status_virtual),
              subscription: !!newUser.subscription,
              flag_point: newUser.subscription === 0 ? 2 : 0
            },
            {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            }
          )
          .then(response => {
            this.loadData();
            (this.showDialog = true),
              (this.dialogMessage = "New device is added!"),
              (this.dialogButtonText = "Ok"),
              (this.newUser.device_id = "");
            console.log(response);
          })
          .catch(error => {
            this.showDialog = true;
            this.dialogHeader = "New device was not added for some reasons";
            this.dialogMessage = `${error.response.data.message}`;
            this.dialogButtonText = "Ok";
          });
        this.dialog = false;
      }
    },

    filterSubscription(subscription, flag_point) {
      if (subscription == false && flag_point == 2) {
        return "Sold by distributor";
      } else if (subscription == false) {
        return "Charge";
      } else {
        return "Subscription";
      }
    },

    removeItem() {
      // this.selected.forEach(item => {
      //   let index = this.users.indexOf(item);
      //   this.users.splice(index, 1);
      // });
      axios
        .post(
          this.$hostname + "/admin/delete_devices",
          {
            device_ids_arr: this.selected.map(item => {
              return item.device_id;
            })
          },
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          console.log(response);
          (this.showDialog = true),
            (this.dialogMessage = "Device(s) was removed"),
            (this.dialogButtonText = "Ok"),
            this.loadData();
        })
        .catch(error => {
          this.showDialog = true;
          this.dialogHeader = "Device wasn't removed";
          this.dialogMessage = `${error.response.data.message}`;
          this.dialogButtonText = "Ok";
        });
      this.selected = [];
    },

    getInfo(userObj) {
      if (userObj.country !== "null") {
        this.showDialog = true;
        this.dialogMessage = `Country: ${userObj.country}, City: ${
          userObj.city
        }, Street: ${userObj.street}, Building: ${userObj.building}, Flat: ${
          userObj.flat
        }, Zip Code: ${userObj.zip_code}, Phone: ${userObj.phone}`;
        this.dialogButtonText = "Ok";
      } else {
        this.showDialog = true;
        this.dialogMessage = "No mobile and address details were received";
        this.dialogButtonText = "Ok";
      }
    },

    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.users.slice();
      }
    },

    openDeviceModal(id) {
      let path = this.$route.path;
      this.$router.push(path + "/" + id);
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    changeStatusItem(event, itemId) {
      // console.log(this.statusItems.indexOf(event), event);
      axios
        .post(
          this.$hostname + "/admin/set_device/",
          {
            device_id: itemId,
            status_physical: this.statusItems.indexOf(event),
            status_virtual: 0
          },
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    },

    changeActionItems(event, itemId) {
      // console.log(this.actionItems.indexOf(event), event)
      axios
        .post(
          this.$hostname + "/admin/set_device/",
          {
            device_id: itemId,
            status_virtual: this.actionItems.indexOf(event)
          },
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    },

    loadData() {
      let url = this.$hostname + "/admin/devices/";
      this.role = localStorage.getItem("role");
      axios
        .get(addFilters(url, this.filters), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.users = response.data.data;
          this.paginationLength = Math.ceil(
            response.data.count / this.rowPerPage[0]
          );
          if (this.role === this.roleAdmin) {
            return axios
              .get(this.$hostname + "/admin/users?role=1", {
                headers: {
                  Authorization: localStorage.getItem("token")
                }
              })
              .then(response => {
                console.log(response);
                this.merchants = response.data.data.map(merchant => {
                  if (merchant.login.indexOf("+") > -1) {
                    let val = merchant.login.split("");
                    let newVal = val.map(symbol => {
                      return symbol == "+" ? "%2B" : symbol;
                    });
                    return { text: merchant.login, value: newVal.join("") };
                  } else {
                    return { text: merchant.login, value: merchant.login };
                  }
                });
                this.merchants.push({ text: "All", value: "" });
              });
          } else {
            this.merchants = [
              { text: "No Merchant", value: "no_merch" },
              { text: "Merch", value: "merch" },
              { text: "All", value: "" }
            ];
          }
        });
    },

    removeGlassesKey(itemId) {
      let formData = new FormData();
      formData.append("device_id", itemId);
      axios
        .post(this.$hostname + "/admin/remove_glasses_key", formData, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.showDialog = true;
          this.dialogMessage = `${error.response.data.message}`;
          this.dialogButtonText = "Ok";
        });
    }
  },

  computed: {
    virtualStatus() {
      return this.filters.status_virtual.text;
    },

    physicalStatus() {
      return this.filters.status_physical.text;
    },

    showDialogEmail() {
      return !!this.$route.params.device_id;
    },

    showHeaderColumn() {
      return this.headers.filter(header => {
        if (!header.hideForMerchant || this.role === this.roleAdmin) {
          return header;
        }
      });
    }
  },

  watch: {
    virtualStatus() {
      if (this.actionItemsSearch.indexOf(this.virtualStatus) == 3) {
        this.filters.status_virtual.value = "";
      } else {
        this.filters.status_virtual.value =
          this.actionItemsSearch.indexOf(this.virtualStatus) + "";
      }
      // this.filters.status_virtual.value = "";
    },

    physicalStatus() {
      if (this.statusItemsSearch.indexOf(this.physicalStatus) == 3) {
        this.filters.status_physical.value = "";
      } else {
        this.filters.status_physical.value =
          this.statusItemsSearch.indexOf(this.physicalStatus) + "";
      }
    },

    newUser: {
      handler() {
        if (this.newUser.subscription === 0) {
          this.newUser.status_physical = "Awaiting for Activation";
        }
      },
      deep: true
    },

    filters: [
      {
        handler() {
          // console.log(this.filters.status_virtual.value, this.filters.status_virtual.text)
          this.loadData();
        },
        deep: true
      }
    ]
  },

  filters: {
    transformMerchantData(value) {
      if (value === "null") {
        return "No Merchant";
      } else {
        return value;
      }
    },
    
    transformPurchaseData(value) {
      if (!value) {
        return "Charge";
      } else {
        return "Subscription";
      }
    }
  }
};
</script>

<style lang="scss">
.add-device-dialog {
  position: relative;
  padding: 50px 100px 30px;
  .v-card__title {
    color: #707070;
    justify-content: center;
    padding-top: 0;
  }
  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}

.device-table {
  .v-datatable {
    thead {
      background-color: #383838;
      .header-text {
        th,
        i {
          color: #fff !important;
        }
      }
      .header-filter {
        background-color: #fff;
      }
    }
  }
}

.pagination {
  padding-bottom: 10px;
}

table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

.v-input,
.v-list__tile {
  font-size: 14px;
}

.v-input .v-input__control {
  margin-bottom: 0;
}
</style>
